import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { PatientTagComponent } from "./patient-tags.component";


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PatientTagComponent
  ],
  exports: [
    PatientTagComponent
  ]
})
export class PatientTagComponentModule { }